import { z } from 'zod'

export const roleSchema = z.enum([
  'employee',
  'manager',
  'hod',
  'hr',
  'director',
  'exec_director',
  'admin',
  'superadmin',
])

export type Role = z.infer<typeof roleSchema>

export const ROLE_HIERARCHY: Record<Role, number> = {
  employee: 0,
  manager: 1,
  hod: 2,
  hr: 3,
  director: 4,
  exec_director: 5,
  admin: 6,
  superadmin: 7,
}

export function roleAtLeast(role: Role, minimum: Role): boolean {
  return ROLE_HIERARCHY[role] >= ROLE_HIERARCHY[minimum]
}

export const rolesSchema = z.array(roleSchema).min(1)

/** Highest-ranked role in the set. An empty array intentionally returns the
 *  'employee' safe default — this is a display-only helper; RBAC gates use
 *  `rolesAtLeast` instead. */
export function primaryRole(roles: Role[]): Role {
  return roles.reduce(
    (best, r) => (ROLE_HIERARCHY[r] > ROLE_HIERARCHY[best] ? r : best),
    roles[0] ?? 'employee',
  )
}

export function rolesAtLeast(roles: Role[], minimum: Role): boolean {
  return roles.some((r) => roleAtLeast(r, minimum))
}
